module.exports = __webpack_public_path__ + "static/media/business-house-r.32752ccd.png";